import React, { useState } from 'react';
import { Typography } from '@mui/material';
import visaImage from '../../assets/visa.svg';
import mastercardImage from '../../assets/mastercard.svg';
import amexImage from '../../assets/amex.svg';
import discoverImage from '../../assets/discover.svg';
import jcbImage from '../../assets/jcb.svg';
import defaultCardImage from '../../assets/defaultCard.svg';
import bankTransferImage from '../../assets/bank-transfer.svg';
import dinersImage from '../../assets/diners.svg';
import unionpayImage from '../../assets/unionpay.svg';
import { PaymentMethodParams, PaymentMethodType } from '../../types';

interface PreferredPaymentMethodProps {
    paymentMethod: PaymentMethodParams;
    onPaymentMethodSelected: (isSelected: boolean) => void;
}
interface CardImages {
    [key: number]: string;
}

const cardImages: CardImages = {
    [PaymentMethodType.VISA]: visaImage,
    [PaymentMethodType.MASTERCARD]: mastercardImage,
    [PaymentMethodType.AMEX]: amexImage,
    [PaymentMethodType.DISCOVER]: discoverImage,
    [PaymentMethodType.JCB]: jcbImage,
    [PaymentMethodType.DINERS]: dinersImage,
    [PaymentMethodType.UNIONPAY]: unionpayImage,
    [PaymentMethodType.DEFAULT]: defaultCardImage,
    [PaymentMethodType.BANK]: bankTransferImage,
};

const PreferredPaymentMethod: React.FC<PreferredPaymentMethodProps> = ({ paymentMethod, onPaymentMethodSelected }) => {
    const [selected, setSelected] = useState(false);

    const handleSelect = () => {
        const newSelected = !selected;
        setSelected(newSelected);
        onPaymentMethodSelected(newSelected);
    };

    const cardImage = cardImages[paymentMethod.cardType] || cardImages[PaymentMethodType.DEFAULT];
    let cardTypeName = PaymentMethodType[paymentMethod.cardType] || 'Card';

    if (paymentMethod.cardType == PaymentMethodType.BANK) {
        cardTypeName = 'Bank Account';
    }

    return (
        <>
            <Typography variant="h6">Use Default Payment Method</Typography>
            <div onClick={handleSelect} style={{ marginBottom: '25px', border: '1px solid #bbbbbb', borderRadius: '5px', padding: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: selected ? '#eee' : 'white' }}>
                {cardImage && <img src={cardImage} alt={`${cardTypeName} Flag`} style={{ width: '50px' }} />}
                <span>{cardTypeName} {paymentMethod.cardNumber && <>(Ending with {paymentMethod.cardNumber.slice(-4)})</>}</span>
                <span>{paymentMethod.cardExpire}</span>
            </div>
        </>
    );
};

export default PreferredPaymentMethod;
